import { render, staticRenderFns } from "./attributeDialog.vue?vue&type=template&id=a5b904b4&scoped=true&"
import script from "./attributeDialog.vue?vue&type=script&lang=js&"
export * from "./attributeDialog.vue?vue&type=script&lang=js&"
import style0 from "./attributeDialog.vue?vue&type=style&index=0&id=a5b904b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b904b4",
  null
  
)

export default component.exports